var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("a", { class: _vm.className, attrs: { href: _vm.url } }, [
      _c(
        "label",
        {
          staticClass: "pointer oc-settings-uploading",
          attrs: { for: "vue-upload-photo" }
        },
        [_vm._v("Загрузить фотографию")]
      )
    ]),
    _vm._v(" "),
    _vm.hasPhoto
      ? _c(
          "a",
          {
            class: _vm.className,
            staticStyle: { "margin-left": "10px", "font-weight": "300" },
            attrs: { href: _vm.url },
            on: {
              click: function($event) {
                return _vm.$emit("del")
              }
            }
          },
          [_c("label", { staticClass: "pointer" }, [_vm._v("Удалить")])]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("input", {
      staticStyle: { position: "fixed", top: "-100em" },
      attrs: { id: "vue-upload-photo", type: "file" },
      on: { change: _vm.uploadPhoto }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e49b771", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e49b771","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/form/UploadPhoto.vue
// module id = 123
// module chunks = 0